module.exports = __webpack_public_path__ + "static/media/11NEPAD11.86aa8427.jpg";